export const it = {
  statHandleReport: {
    action: "Azione",
    company: "Azienda",
    count: "Giacenza",
    date: "Data",
    handleReportInitialCount: "Saldo iniziale giacenza",
    handleReportCount: "Saldo finale giacenza",
    handleReportPaper: "Resoconto su movimentazione",
    handleReportPeak: "Picco massimo giacenza",
    month: "Mese",
    name: "Movimentazione",
    parcel: "UDC",
    parcelStates: {
      created: "Creato",
      deleted: "Eliminato",
      loaded: "Caricato",
      loosened: "Libero",
      sent: "Spedito",
      stored: "Immagazzinato",
      unknown: "Sconosciuto",
    },
    period: "Periodo di riferimento",
    periodShort: "Periodo",
    shipment: "Spedizione",
    shipmentDetail: "Spedizione {code} del {date} da {companyName}",
  },
};
